module.exports = __webpack_public_path__ + "img/button_ok.4caac93a.png";